import React, { useCallback, useEffect, useRef } from 'react';

import { observer } from 'mobx-react-lite';
import { freeBetStore, useOutsideClick } from '@pascal/pascal-core';

import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { oddStore } from '../../store/oddStore';
import { reBetStore } from '../../store/reBetStore';
import { quickBetStore } from '../../store/quickBetsStore';

import PigImage from './pigImage';
import BetButton from './betButton';
import AutoCashOut from './autoCashOut';
import QuickActionPopOver from './quickActionPopOver';
import { doBetStore } from '../../store/doBetStore';

const BetItem = observer(
  ({
    betId,
    itemId,
    isSave,
    freeBetId,
    isMinOddNull,
    freeBetMinOdd,
    betAmount,
    winAmount,
    isDisabled,
    sendCashOut,
    setBetAmount,
    isBetsClosed,
    isBetAccepted,
    autoCashOutOdd,
    isOpenBetPopup,
    isNextRoundBet,
    totalBetForNote,
    betAmountPopupId,
    setAutoCashOutOdd,
    setIsOpenBetPopup,
    setTotalBetForNote,
    isOpenCashOutPopup,
    setBetAmountPopupId,
    autoCashOutQuickOdds,
    setIsOpenCashOutPopup,
    autoCashOutOddPopupId,
    isNextRoundAutoCashOut,
    setAutoCashOutOddPopupId,
    setIsNexRoundAutoCashOut,
  }) => {
    const settingRef = useRef();
    const [opened, setToggle] = useOutsideClick(settingRef);

    const { quickBets } = quickBetStore;
    const { activeFreeBet } = freeBetStore;

    useEffect(() => {
      const limits = gameConfigStore.limits;
      if (activeFreeBet.id) {
        quickBetStore.setQuickBets([activeFreeBet.amount]);
      } else {
        quickBetStore.setQuickBets(limits.quickBets);
      }
    }, [activeFreeBet.id]);

    const onSelectQuickBet = useCallback(() => {
      isOpenBetPopup && setIsOpenBetPopup(false);
      isOpenCashOutPopup && setIsOpenCashOutPopup(false);
    }, [isOpenBetPopup, setIsOpenBetPopup, isOpenCashOutPopup, setIsOpenCashOutPopup]);

    const oddCurrentValue = oddStore.oddData[itemId];

    const selectedAmount = useCallback(
      ({ id, value }) => {
        setTotalBetForNote(totalBetForNote + value);
        setIsNexRoundAutoCashOut(id, true);
        if (betAmountPopupId || betAmountPopupId === 0) {
          setBetAmount(id, value);
          setBetAmountPopupId(null);
          // iframeService.sendStakeUpdate(
          //   doBetStore.pigs.reduce((acc, curr) => acc + curr.betAmount, 0)
          // );
        } else if (autoCashOutOddPopupId || autoCashOutOddPopupId === 0) {
          setAutoCashOutOdd(id, value);
          setAutoCashOutOddPopupId(null);
        }
      },
      [
        setBetAmount,
        totalBetForNote,
        betAmountPopupId,
        setAutoCashOutOdd,
        setTotalBetForNote,
        setBetAmountPopupId,
        autoCashOutOddPopupId,
        setAutoCashOutOddPopupId,
        setIsNexRoundAutoCashOut,
      ]
    );

    const handleQuickActions = useCallback(
      (event, value) => {
        event.stopPropagation();
        reBetStore.setIsReBetClick(false);
        // const allBetAmount = doBetStore.pigs.reduce((acc, curr) => acc + curr.betAmount, 0);

        // if ((value > balance || allBetAmount > balance - value) && !isNextRoundBet) {
        //   notificationStore.setNotificationType(BetResponseCode.InsufficientFunds);
        //   setBetAmountPopupId(null);
        //   setTimeout(() => notificationStore.setNotificationType(null), 1000);
        //   doBetStore.pigs = doBetStore.pigs.map((item, index) =>
        //     +itemId === +index ? { ...item, betAmount: null } : { ...item }
        //   );
        // } else {
        selectedAmount({ id: itemId, value });
        // }
      },
      [itemId, selectedAmount]
    );

    const handleCancelAction = useCallback(
      (id) => {
        setToggle();
        if ((betAmountPopupId || betAmountPopupId === 0) && (!isBetAccepted || !isBetsClosed)) {
          const canceledBetAmount = doBetStore.pigs.find((pig) => pig.id === id).betAmount;

          setTotalBetForNote(totalBetForNote - canceledBetAmount);
          setBetAmount(id, 0);
          setBetAmountPopupId(null);
          // iframeService.sendStakeUpdate(
          //   doBetStore.pigs.reduce((acc, curr) => acc + curr.betAmount, 0)
          // );
        } else if (autoCashOutOddPopupId || autoCashOutOddPopupId === 0) {
          setAutoCashOutOdd(id, 0);
          setAutoCashOutOddPopupId(null);
        }
      },
      [
        setToggle,
        setBetAmount,
        isBetsClosed,
        isBetAccepted,
        totalBetForNote,
        betAmountPopupId,
        setAutoCashOutOdd,
        setTotalBetForNote,
        setBetAmountPopupId,
        autoCashOutOddPopupId,
        setAutoCashOutOddPopupId,
      ]
    );

    const handleOpenPopUp = (event, callback) => {
      event.stopPropagation();
      callback(itemId);
      !opened && setToggle();
    };

    return (
      <div className='c-m-bets-item'>
        <div
          className={`c-m-bets-item-left-side ${!isBetAccepted && !betAmount ? 'pulse-anim' : ''}`}
        >
          <PigImage
            itemId={itemId}
            isSave={isSave}
            winAmount={winAmount}
            oddCurrentValue={oddCurrentValue}
          />
          <BetButton
            betId={betId}
            itemId={itemId}
            freeBetId={freeBetId}
            freeBetMinOdd={freeBetMinOdd}
            winAmount={winAmount}
            betAmount={betAmount}
            isMinOddNull={isMinOddNull}
            isDisabled={isDisabled}
            sendCashOut={sendCashOut}
            isBetAccepted={isBetAccepted}
            isNextRoundBet={isNextRoundBet}
            oddCurrentValue={oddCurrentValue}
            handleOpenPopUp={handleOpenPopUp}
            setBetAmountPopupId={setBetAmountPopupId}
          />
          {betAmountPopupId === itemId && opened && (
            <QuickActionPopOver
              isBetAmount
              itemId={itemId}
              data={quickBets}
              settingRef={settingRef}
              onSelectQuickBet={onSelectQuickBet}
              handleCancelAction={handleCancelAction}
              handleQuickActions={handleQuickActions}
            />
          )}
        </div>
        <div className='c-m-bets-item-right-side'>
          <AutoCashOut
            betId={betId}
            isDisabled={isDisabled}
            autoCashOutOdd={autoCashOutOdd}
            handleOpenPopUp={handleOpenPopUp}
            isNextRoundAutoCashOut={isNextRoundAutoCashOut}
            setAutoCashOutOddPopupId={setAutoCashOutOddPopupId}
          />
          {autoCashOutOddPopupId === itemId && opened && (!betId || !betAmount) && (
            <QuickActionPopOver
              isAutoCashOut
              itemId={itemId}
              settingRef={settingRef}
              data={autoCashOutQuickOdds}
              onSelectQuickBet={onSelectQuickBet}
              handleQuickActions={handleQuickActions}
              handleCancelAction={handleCancelAction}
            />
          )}
        </div>
      </div>
    );
  }
);

export default BetItem;
